module.exports = "/wwwroot/img/automatic_related_pages_lift_block.png?ver=430b76aa";